export default __webpack_public_path__ + "932953651d57f6582c9b1f951e9ff767.svg";